<template>
  <div class="app-security-code">
    <label class="app-security-code__label" :for="`code-${uuid}`">
      <ul :class="`${theme}-container app-security-code__container`">
        <li
          class="app-security-code__field"
          v-for="(item, index) in length"
          :key="index"
          :class="{
            'app-security-code__field--active':
              (index === value.length && inputFocus) ||
              (index === length - 1 && value.length === length && inputFocus),
          }"
        >
          <i class="app-security-code__char-field">{{
            value[index] || placeholder
          }}</i>
        </li>
      </ul>
    </label>
    <input
      ref="input"
      class="app-security-code__input"
      @keyup="handlerInput($event)"
      @focus="handlerFocus()"
      @blur="handlerBlur()"
      v-model="value"
      :id="`code-${uuid}`"
      :name="`code-${uuid}`"
      type="tel"
      :maxlength="length"
      autocorrect="off"
      autocomplete="off"
      autocapitalize="off"
    />
  </div>
</template>

<script>
import { nanoid } from 'nanoid';

export default {
  name: 'SecurityCode',
  // component properties
  props: {
    length: {
      type: Number,
      default: 6,
    },
    placeholder: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: 'block',
    },
    isFocus: {
      type: Boolean,
      default: false,
    },
  },
  // variables
  data: () => ({
    value: '',
    inputFocus: false,
  }),
  computed: {
    uuid() {
      return nanoid();
    },
  },
  mounted() {
    if (this.isFocus) {
      this.$refs.input.focus();
    }
  },
  methods: {
    /**
     * Скрывает клавиатуру у моб устройств
     */
    hideKeyboard() {
      document.activeElement.blur(); // ios
      this.$refs.input.blur(); // android
    },
    /**
     * Действие на событие submit
     */
    handlerSubmit() {
      this.$emit('input', this.value);
    },
    /**
     * Действие на событие input
     * @param e
     */
    handlerInput(e) {
      if (e.target.value.length >= this.length) {
        this.hideKeyboard();
      }
      this.handlerSubmit();
    },
    /**
     * Действие на событие focus
     */
    handlerFocus() {
      this.inputFocus = true;
    },
    /**
     * Действие на событие blur
     */
    handlerBlur() {
      this.inputFocus = false;
    },
  },
};
</script>

<style scoped lang="scss">
.app-security-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  &__label {
    width: 100%;
  }

  &__input {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  &__container {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0;
  }

  &__field {
    display: flex;
    font-size: 20px;
    font-weight: 600;
    line-height: 54px;
    text-align: center;
    list-style: none;
    background: $white;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    box-shadow: none;
    transition: box-shadow $A;

    @include size(56px);

    &--active {
      position: relative;
      box-shadow: $box-shadow-active;

      &::before {
        position: absolute;
        top: 50%;
        right: 8px;
        width: 1px;
        height: 33px;
        content: '';
        background: #000;
        transform: translateY(-50%);
        animation-name: fadeOut;
        animation-duration: 1s;
        animation-timing-function: cubic-bezier(1, 0, 0, 1);
        animation-iteration-count: infinite;
      }
    }
  }

  &__char-field {
    margin: auto;
    font-style: normal;
  }
}

.block-container {
  .app-security-code__field {
    margin: 2px;
    color: $black;
    background-color: $white;
  }
}

.line-container {
  position: relative;
  background-color: $white;

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    box-sizing: border-box;
    width: 200%;
    height: 200%;
    content: '';
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    transform: scale(0.5);
    transform-origin: 0 0;
  }

  .app-security-code__field {
    position: relative;
    flex: 1;

    &:not(:last-child)::after {
      position: absolute;
      top: 25%;
      right: 0;
      width: 1px;
      height: 50%;
      content: '';
      background: #d9d9d9;
      transform: scaleX(0.5);
    }
  }
}
</style>
